import { render, staticRenderFns } from "./FooterPaymentList.vue?vue&type=template&id=d52145e4&scoped=true&"
import script from "./FooterPaymentList.vue?vue&type=script&lang=js&"
export * from "./FooterPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52145e4",
  null
  
)

export default component.exports